import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { addRisk } from "../../../../../actions/Utilities/Risk";
import { toast } from "../../../../../components/toastNotification";
import { RiskDataType } from "../types/RiskInterface";

export default function useAddRisk() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((NewData: RiskDataType) => addRisk(NewData), {
    onSuccess: (res: any) => {
      if (res === "Duplicate") {
        toast.fire("Saving Failed", "The data already exists!", "error");
      } else {
        queryClient.invalidateQueries(["GetRisk"]);
        toast.fire("Success", "Risk Added Successfully", "success");
      }
    },

    onError: (error: any) => {
      if (
        error.response.data.message === "Failed sending of email" ||
        error.response.data.message === "Failed inserting of notification"
      ) {
        toast.fire(
          "Success",
          "Risk added successfully, but " + error.response.data.message,
          "warning"
        );
        queryClient.invalidateQueries("GetRisk");
      } else {
        toast.fire("Add Risk failed", "Server Error: Cannot add Risk", "error");
      }
    },
  });

  return mutate;
}
